import { BillingData, PaymentPlan, RegistrationSetting } from 'Douleutaras/types';

export class BillingDataClass implements BillingData {

  autoTopUp: RegistrationSetting;
  currentProd: PaymentPlan;

  private products: Array<PaymentPlan> = [];

  get creditData(): BillingData['creditData'] {
    return {
      products: this.products,
      autotopup: this.autoTopUp,
      current_prod: this.currentProd
    };
  }

  addProduct(product: PaymentPlan): void {
    this.products.push(product);
  }

  hasAutoTopProduct(id: number): boolean {
    if (!this.autoTopUp || !this.autoTopUp.products || !this.autoTopUp.products.length) {
      return false;
    }

    return this.autoTopUp.products[0].product.id === id;
  }

}
